import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-public-integration',
  templateUrl: './public-integration.component.html',
  styleUrls: ['./public-integration.component.scss']
})
export class PublicIntegrationComponent implements OnInit {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0)
      }
    });
  }

  ngOnInit(): void {
  }

}
